"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const ClaquetaM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 197.971 199" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M180.809 79.688H26.339L189.272 36.03a9.828 9.828 0 006.939-12.013l-4.5-16.746a9.813 9.813 0 00-12-6.939L7.265 46.537A9.821 9.821 0 00.336 58.55l4.487 16.755a9.789 9.789 0 008.112 7.156A17.155 17.155 0 005.107 96.85v84.988A17.184 17.184 0 0022.269 199h158.54a17.184 17.184 0 0017.162-17.162V96.85a17.189 17.189 0 00-17.162-17.162zm-33.255 11.444h14.787l-8.132 21.725h-14.171zm-25.379 0h15l-7.516 21.725h-15zm-25.606 0H111.8l-7.516 21.725h-15.24zm-25.161 0h14.777l-8.122 21.725H63.892zm-25.379 0h15l-7.526 21.725h-14.99zm-10.375 0l-7.526 21.725H16.551V96.85a5.726 5.726 0 015.718-5.718zm129.015-76.619l17.579-4.7 4.487 16.746-23.372 6.257zm-24.3 6.522l14.285-3.835-1.306 18.3-14.285 3.825zm-24.528 6.57l14.5-3.891-1.307 18.3-14.5 3.891zm-24.724 6.626l14.71-3.947-1.306 18.3-14.711 3.945zm-24.3 6.5l14.275-3.821-1.306 18.3-14.275 3.822zM42.3 47.3l14.493-3.881-1.306 18.3L40.993 65.6zM9.811 56.013l22.464-6.021-1.307 18.3L14.3 72.758zm176.716 125.825a5.728 5.728 0 01-5.718 5.727H22.269a5.728 5.728 0 01-5.718-5.727v-59.174h169.976zm0-68.981H165.2l7.517-21.725h8.093a5.726 5.726 0 015.718 5.718z" }))));
};
exports.default = ClaquetaM;
//# sourceMappingURL=index.js.map